import React from 'react';
import { Link } from 'react-router-dom';
import '../css/notfound.css';

const NotFound = () => {
    return (
        <div className="notfound-container">
            <div className="notfound-content">
                <h1 className="notfound-title">404</h1>
                <h2 className="notfound-subtitle">Oops! Page Not Found</h2>
                <p className="notfound-text">
                    The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                </p>

                <div className="notfound-links">
                    <p>Try one of these helpful links instead:</p>
                    <div className="links-group">
                        <Link to="/" className="notfound-btn">Go to Home</Link>
                        <Link to="/about-us" className="notfound-btn secondary">About Us</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;